export const PREDEFINED_VARIABLES = {
  USER: [
    "FIRST_NAME",
    "LAST_NAME",
    "FULL_NAME",
    "EMAIL",
    "COMPANY",
    "ROLE"
  ],
  CONTENT: [
    "DYNAMIC_TOPIC",
    "TOP_STORY",
    "MARKET_HIGHLIGHTS",
    "COMPANY_UPDATES",
    "INNOVATION_UPDATES",
    "MARKET_TRENDS",
    "TECH_SPOTLIGHT",
    "BATTERY_UPDATES",
    "MANUFACTURING_UPDATES"
  ],
  METRICS: [
    "MARKET_POINT_1",
    "MARKET_POINT_2",
    "MARKET_POINT_3",
    "MARKET_CAPS",
    "PRODUCTION_NUMBERS",
    "INVESTMENT_FLOWS"
  ]
} as const;